module.exports = __webpack_public_path__ + "img/receivebox_mint3.0f01f43d.png";